export default class extends Controller {
  connect() {
    App.Chart.init(this.element);
  }
};



// WEBPACK FOOTER //
// ./app/components/charts/assets/javascript/charts-pie-controller.js